import styled from 'styled-components';

export const RadarContainer = styled.div`
  position: relative;
  width: 300px;
  height: 300px;
  margin: 0 auto;
  z-index: 3;
`;

export const RadarBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);
  z-index: 1;
  
  &::before {
    content: '';
    position: absolute;
    top: 20%;
    left: 20%;
    width: 60%;
    height: 60%;
    background: rgba(0, 0, 0, 0.2);
    clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 30%;
    left: 30%;
    width: 40%;
    height: 40%;
    background: rgba(0, 0, 0, 0.2);
    clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);
  }
`;

export const RadarData = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 120, 255, 0.5);
  z-index: 2;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(0, 90, 255, 0.8), rgba(0, 140, 255, 0.3));
  }
`;

export const AttributeLabel = styled.div`
  position: absolute;
  font-size: 0.875rem;
  text-align: center;
  z-index: 3;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AttributeValue = styled.div`
  display: inline-block;
  padding: 4px 12px;
  text-align: center;
  font-weight: bold;
  border-radius: 4px;
  margin-bottom: 4px;
  color: white;
  
  &.alt {
    background-color: #71b048;
  }
  
  &.cre {
    background-color: #254e9e;
  }
  
  &.tec {
    background-color: #68954a;
  }
  
  &.def {
    background-color: #923032;
  }
  
  &.tac {
    background-color: #af4c3e;
  }
`;

export const AttributeText = styled.div`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  background-color: rgba(30, 41, 59, 0.8);
`; 